import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

const TOKEN_KEY = "crtm_auth_token";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined=checking, null=anon, object=logged
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      api
        .get("/auth/me")
        .then((r) => setUser(r.data))
        .catch(() => {
          localStorage.removeItem(TOKEN_KEY);
          delete api.defaults.headers.common["Authorization"];
          setUser(null);
        });
    } else {
      setUser(null);
    }
  }, []);

  const login = async (username, password) => {
    setError(null);
    try {
      const r = await api.post(
        "/auth/login",
        { username, password },
        { withCredentials: true }
      );
      localStorage.setItem(TOKEN_KEY, r.data.token);
      api.defaults.headers.common["Authorization"] = `Bearer ${r.data.token}`;
      setUser(r.data.user);
      return true;
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setError(
        typeof detail === "string"
          ? detail
          : Array.isArray(detail)
          ? detail.map((d) => d.msg || JSON.stringify(d)).join(" ")
          : "Error de autenticación"
      );
      return false;
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common["Authorization"];
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, error, setError }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
